export default __webpack_public_path__ + "static/commerce-1-040da1ea3a923ec2772b0ccd4e5ef972.png";